import { createVegaChart } from "./vega_chart_helpers";

export function initializeChart(container_id, grid_item, chart_configuration = {}){
  var chart_container = $(container_id)
  var breakdownAttribute = chart_container.data("breakdownAttribute")
  var ajaxResponseData = eval(chart_container.data("graphService"));
  var labelkey = chart_container.data("labelKey");

  var chartLayout = chart_configuration.chartLayout;
  var chartScale = chart_configuration.chartScale;
  var hidePoint = chart_configuration.hidePoint;

  if (ajaxResponseData) {
    let graph_settings_enabled = grid_item.find(".graph-settings").length > 0

    let dimensions = {}
    if(chart_configuration.dimensions){
      dimensions = chart_configuration.dimensions
    } else {
      dimensions = adjustGraphDimensions(grid_item.width(), grid_item.height())
    }

    if(graph_settings_enabled) dimensions.height = dimensions.height - 40
    if(grid_item.parent().find("article header p").text().length > 0) dimensions.height = dimensions.height - 40

    createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale, dimensions.width, dimensions.height, false)
  }
}

export function adjustGraphDimensions(container_width, container_height){
  return { width: container_width - 80, height: container_height - 40 }
}